import $ from 'jquery'

const menuOpenClass = 'mobile-header--panel-open'
const menuOpenBodyClass = 'page--has-open-mobile-menu'
const menuPanelClass = 'mobile-header__panel'
const menuOpenButtonClass = 'mobile-header__open-button'
const menuCloseButtonClass = 'mobile-header__panel__close-button'

export default class MobileMenuController {
  constructor (element) {
    this._element = element
    this._panelElement = element.querySelector('.' + menuPanelClass)
    this._bindUIActions()
  }

  open () {
    console.log('open')
    $(this._panelElement).fadeIn(250)
    this._element.classList.add(menuOpenClass)
    document.body.classList.add(menuOpenBodyClass)
  }

  close () {
    console.log('close')
    document.body.classList.remove(menuOpenBodyClass)
    $(this._panelElement).fadeOut(250)
    setTimeout(() => {
      this._element.classList.remove(menuOpenClass)
    }, 260)
  }

  isOpen () {
    return this._element.classList.contains(menuOpenClass)
  }

  _bindUIActions () {
    const openButton = this._element.querySelector('.' + menuOpenButtonClass)
    if (openButton) {
      openButton.addEventListener('click', (e) => {
        this.open()
        e.preventDefault()
      })
    }

    const closeButton = this._element.querySelector('.' + menuCloseButtonClass)
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        this.close()
        e.preventDefault()
      })
    }
  }
}
